// Whole rupees without decimals, otherwise two decimals (e.g. 20.5 -> "20.50").
export const formatRupees = (n) => {
  const value = Math.round((Number(n) || 0) * 100) / 100;
  return Number.isInteger(value) ? String(value) : value.toFixed(2);
};
